const en = {
  appName: 'Scrabble Mini',
  taglineLong: 'OUTscore. OUTthink. OUTplay.',
  taglineShort: 'OUTthink',
  navValidator: 'Validator',
  navFinder: 'Finder',
  navAnagram: 'Anagram',
  navMagic: 'Magic',
  navPractice: 'Practice',
  navDocs: 'Docs',
  languageLabel: 'Language',
  languageEnglish: 'English',
  languageSpanish: 'Español',

  wordValidatorTitle: 'Word Validator',
  wordValidatorSubtitle:
    'Wondering if that word is valid? Type it in and find out instantly! You\'ll also see exactly how many points it\'s worth.',
  wordValidatorHowItWorksTitle: 'Quick Tips',
  wordValidatorHowItWorks1: 'Type any word you want to check',
  wordValidatorHowItWorks2: 'Use * or ? for blank tiles',
  wordValidatorHowItWorks3: 'We\'ll check it against 370,000+ words',
  wordValidatorHowItWorks4: 'See the score breakdown instantly',
  wordValidatorHowItWorks5: 'Learn what each letter is worth',
  wordValidatorSlotTitle: 'Word #{slot}',
  wordValidatorCheckWord: 'Check a Word',
  wordValidatorInputPlaceholder: 'Enter word (e.g., SCRABBLE)',
  wordValidatorCheckButton: 'Check',
  wordValidatorCheckingButton: 'Checking...',
  wordValidatorErrorEmpty: 'Enter letters A–Z (use * or ? for blanks)',
  wordValidatorErrorBlanks: 'Words with blanks cannot be validated',
  wordValidatorErrorLookupFailed: 'Lookup failed',
  wordValidatorLabelWord: 'Word:',
  wordValidatorLabelValidity: 'Validity:',
  wordValidatorNotChecked: 'Not checked',
  wordValidatorValid: 'Valid',
  wordValidatorNotInDictionary: 'Not in dictionary',
  wordValidatorLabelBaseScore: 'Base Score:',
  wordValidatorLetterBreakdownTitle: 'Letter Breakdown:',
  wordValidatorBlankLabel: '(blank)',
  wordValidatorPointsSuffix: 'pts',
  wordValidatorScoringRefTitle: 'Scrabble Scoring Reference',
  wordValidatorPointsLabel1: '1 point:',
  wordValidatorPointsLabel2: '2 points:',
  wordValidatorPointsLabel3: '3 points:',
  wordValidatorPointsLabel4: '4 points:',
  wordValidatorPointsLabel5: '5 points:',
  wordValidatorPointsLabel8: '8 points:',
  wordValidatorPointsLabel10: '10 points:',
  wordValidatorNoteBaseOnly:
    'Note: Scores shown are base values only. Actual Scrabble scores include board multipliers (Double/Triple Letter/Word).',

  // AI Definition Card
  definitionCardTitle: 'Word Definition',
  definitionCardNoWord: 'No word yet',
  definitionCardPrompt: 'Check a word and we\'ll show you what it means!',
  definitionCardInvalidWord: 'Hmm, that\'s not in our dictionary',
  definitionCardInvalidPrompt: 'Try another word to see its definition.',
  definitionCardLoading: 'Looking it up...',
  definitionCardError: 'Oops! Couldn\'t get the definition',
  definitionCardExamples: 'Examples',
  definitionCardEtymology: 'Etymology',
  definitionCardScrabbleTip: 'Scrabble Tip',

  wordFinderTitle: 'Word Finder',
  wordFinderSubtitle:
    'Got a tricky letter like Q or Z? We\'ll show you the best words to play with it. Filter by where the letter appears and how long you want the word.',
  wordFinderProTipTitle: 'Helpful Hint',
  wordFinderProTipText:
    'Looking for words ending in "S"? Great for hooking onto existing words! Or try finding words starting with "Q" when you\'ve got that tough tile.',
  wordFinderFiltersTitle: 'Search Filters',
  wordFinderQuickSelectTitle: 'Quick Select (High-Value Letters):',
  wordFinderSelectLetterLabel: 'Select Letter:',
  wordFinderLetterPositionLabel: 'Letter Position:',
  wordFinderPositionAnywhere: 'Anywhere',
  wordFinderPositionStarts: 'Starts with',
  wordFinderPositionEnds: 'Ends with',
  wordFinderWordLengthLabel: 'Word Length: {min} - {max} letters',
  wordFinderMinLabel: 'Min: {value}',
  wordFinderMaxLabel: 'Max: {value}',
  wordFinderQuickPresetsTitle: 'Quick Presets:',
  wordFinderPresetTwoLetter: '2-letter words',
  wordFinderPresetBingo: '7-letter (Bingo)',
  wordFinderPresetAll: 'All lengths',
  wordFinderSidebarTitle: 'Letter:',
  wordFinderStatPointValue: 'Point Value',
  wordFinderStatTotalWords: 'Total Words',
  wordFinderStatHighestScore: 'Highest Score',
  wordFinderStatAverageScore: 'Average Score',
  wordFinderResultsTitle: 'Top 10 Results',
  wordFinderLoading: 'Loading...',
  wordFinderNoWordsTitle: 'No words found matching your criteria.',
  wordFinderNoWordsHint: 'Try adjusting your filters.',
  wordFinderTableRank: 'Rank',
  wordFinderTableWord: 'Word',
  wordFinderTableLength: 'Length',
  wordFinderTableScore: 'Score',

  anagramTitle: 'Anagram Solver',
  anagramSubtitle:
    'Stuck with a rack of tiles? Enter them here and we\'ll find every word you can make. You might discover some you\'ve never heard of!',
  anagramProTipTitle: 'Did You Know?',
  anagramProTipText:
    'Use all 7 tiles and you get a 50-point bonus! That\'s called a BINGO. Use ? or * for blank tiles—they can be any letter.',
  anagramTilesTitle: 'Your Tiles',
  anagramTilesLabel: 'Enter your tiles (A-Z, use ? or * for blanks):',
  anagramPlaceholder: 'e.g., RETAINS or RETA?NS',
  anagramTilesEntered: '{count} tile{s} entered',
  anagramClear: 'Clear',
  anagramLengthLabel: 'Word Length: {min} - {max} letters',
  anagramMinLabel: 'Min: {value}',
  anagramMaxLabel: 'Max: {value}',
  anagramShowBingosOnly: 'Show only 7+ letter words (Bingos)',
  anagramFindWords: 'Find Words',
  anagramSolving: 'Solving...',
  anagramTryExamples: 'Try these examples:',
  anagramExampleWithBlank: 'RETA?NS (with blank)',
  anagramResultsSummary: 'Results Summary',
  anagramSummaryPrompt: 'Enter your tiles and click "Find Words" to see results.',
  anagramTotalWordsFound: 'Total Words Found',
  anagramBingoWords: 'Bingo Words (7+)',
  anagramBingoBonus: '+50 bonus points each!',
  anagramBingoBadge: 'BINGO +50',
  anagramHighestScore: 'Highest Score',
  anagramAverageScore: 'Average Score',
  anagramWordsFound: '{count} Word{s} Found',
  anagramNoWordsFound: 'No Words Found',
  anagramNoWordsText: 'No words found with those tiles.',
  anagramNoWordsHint: 'Try different letters or adjust your filters.',
  anagramShowingTop: 'Showing top 50 of {count} results',
  anagramTableRank: 'Rank',
  anagramTableWord: 'Word',
  anagramTableLength: 'Length',
  anagramTableScore: 'Score',

  // Magic Search
  magicTitle: 'Magic Search',
  magicSubtitle: 'Just tell us what you\'re looking for in plain English. Our AI will find the perfect words for you—no complicated filters needed!',
  magicInputPlaceholder: 'Try: "short words with Q but no U" or "7-letter words with X"',
  magicSearchButton: 'Search',
  magicSearching: 'Finding words...',
  magicExamplesTitle: 'Try one of these:',
  magicExample1: 'Short words with Q but no U',
  magicExample2: 'Words that start and end with the same letter',
  magicExample3: 'High-scoring words using only vowels',
  magicResultsTitle: 'Here\'s what we found',
  magicNoResults: 'Hmm, no words matched that. Try asking differently!',
  magicError: 'Oops! Something went wrong',
  magicWhyTitle: 'Why is it called Magic?',
  magicWhyText: 'Because you can just describe what you want! Instead of clicking through filters, simply type things like "words with double letters" or "5-letter words ending in -ING" and we\'ll figure it out.',
  magicPoweredBy: 'Powered by AI',

  // Practice Game
  practiceTitle: 'Word Practice',
  practiceSubtitle: 'Build words, beat the clock, and rack up points. How high can you score?',
  practiceHowToPlay: 'How to Play',
  practiceRule1: 'Click or type letters to build a word (at least 3 letters).',
  practiceRule2: 'Hit Enter or tap Submit to check your word and earn points.',
  practiceRule3: 'Each letter = 5 points. Longer words (5+) get a bonus!',
  practiceRule4: '60 seconds per round, 5 minutes total. Fresh letters every round!',
  practiceStartGame: 'Start Game',
  practiceGameOver: 'Nice Work!',
  practiceFinalScore: 'Your Score',
  practiceWordsPlayed: '{count} words played',
  practicePlayAgain: 'Play Again',
  practiceTotalScore: 'Score',
  practiceGameTime: 'Game',
  practiceRoundTime: 'Round',
  practiceSelectedWord: 'Your Word',
  practiceSelectLetters: 'Tap letters to build a word...',
  practiceMinLetters: 'Need at least {count} letters',
  practicePoints: 'pts',
  practiceBonus: 'bonus',
  practiceInvalidWord: 'Hmm, that\'s not a word!',
  practiceCheckFailed: 'Oops! Couldn\'t check that',
  practiceClear: 'Clear',
  practiceSubmit: 'Submit',
  practiceChecking: 'Checking...',
  practiceSkipRound: 'Skip Round',
  practiceGetHint: 'Get Hint',
  practiceHintLoading: 'Thinking...',
  practiceHintTitle: 'AI Hint',
  practiceHintBestWords: 'Best possible words with your letters:',
  practiceHintMaxScore: 'Max possible score',
  practiceRoundScore: 'Round score',
  practiceHelpTip: 'Type letters or click them. Enter = submit, Backspace = undo, Escape = clear.',
  practiceKeyboardTitle: 'Keyboard Tips',
  practiceKeyboardType: 'Type letters to pick them',
  practiceKeyboardSubmit: 'Submit your word',
  practiceKeyboardRemove: 'Remove last letter',
  practiceKeyboardClear: 'Start over',
  practiceGotIt: 'Got it!',

  homeTitle: 'Your Scrabble Practice Buddy',
  homeSubtitle:
    'Check words, find great plays, and turn tricky tiles into points. Everything you need to level up your game!',
  homeCtaGetStarted: 'Let\'s Go!',
  homeCtaLearnMore: 'See What\'s Inside',
  homeSectionToolsTitle: 'Everything You Need',
  homeToolValidatorTitle: 'Word Validator',
  homeToolValidatorDesc:
    'Not sure if a word is real? Type it in and we\'ll tell you instantly—plus show you exactly how many points it\'s worth.',
  homeToolValidatorBullet1: '• Instant dictionary validation',
  homeToolValidatorBullet2: '• Real-time scoring',
  homeToolValidatorBullet3: '• Letter-by-letter breakdown',
  homeToolValidatorBullet4: '• Blank tile support',
  homeToolFinderTitle: 'Word Finder',
  homeToolFinderDesc: 'Got a tough letter like Q or Z? We\'ll show you the best words to play with it.',
  homeToolFinderBullet1: '• Search by letter position',
  homeToolFinderBullet2: '• Filter by word length',
  homeToolFinderBullet3: '• Statistical analysis',
  homeToolFinderBullet4: '• Quick presets',
  homeToolAnagramTitle: 'Anagram Solver',
  homeToolAnagramDesc:
    'Dump your tiles in and see every word you can make. You might find some you\'ve never heard of!',
  homeToolAnagramBullet1: '• Solve any tile combination',
  homeToolAnagramBullet2: '• Wildcard/blank support',
  homeToolAnagramBullet3: '• Bingo detection (7+ letters)',
  homeToolAnagramBullet4: '• Instant results',
  homeToolCtaTryNow: 'Try it',
  homeToolCtaExplore: 'Explore',
  homeToolCtaSolve: 'Solve',
  homeSectionTechTitle: 'Built With Modern Technologies',
  homeTechReactDesc: 'Modern component architecture',
  homeTechTypeScriptDesc: 'Type-safe codebase',
  homeTechTailwindDesc: 'Responsive design',
  homeTechViteDesc: 'Lightning-fast builds',
  homeHighlightsTitle: 'Why You\'ll Love It',
  homeHighlightDictionaryTitle: 'Huge Dictionary',
  homeHighlightDictionaryDesc: 'Over 370,000 words—if it\'s playable in Scrabble, we\'ve got it.',
  homeHighlightPerformanceTitle: 'Super Fast',
  homeHighlightPerformanceDesc: 'Get answers in under a second. No waiting around!',
  homeHighlightFilteringTitle: 'Smart Filters',
  homeHighlightFilteringDesc: 'Find exactly what you need by position, length, or score.',
  homeHighlightMobileTitle: 'Works Everywhere',
  homeHighlightMobileDesc: 'Phone, tablet, or computer—it all just works.',
  homeStatsWords: 'Words',
  homeStatsTools: 'Tools',
  homeStatsSpeed: 'Speed',
  homeStatsBilingual: 'Languages',
  homeAIPowered: 'AI-Powered',
  homeGameMode: 'Game Mode',
  homeMagicTitle: 'Magic Search',
  homeMagicDesc: 'Just describe what you want in plain English. Our AI figures out the rest!',
  homeMagicCta: 'Try Magic',
  homePracticeTitle: 'Word Practice',
  homePracticeDesc: 'Race the clock and build words from random letters. It\'s like a workout for your vocabulary!',
  homePracticeCta: 'Play Now',
  homeCtaTitle: 'Ready to Up Your Game?',
  homeCtaSubtitle:
    'Jump in and start exploring. All our tools are free and ready to help you become a better player.',
  homeFooterNote:
    'Made with love for word game fans everywhere.',

  footerToolsTitle: 'Tools',
  footerResourcesTitle: 'Resources',
  footerLegalTitle: 'Legal',
  footerLinkDocs: 'Docs',
  footerLinkAbout: 'About',
  footerLinkTechStack: 'Tech Stack',
  footerLinkGitHub: 'GitHub',
  footerLinkPrivacy: 'Privacy Policy',
  footerLinkTerms: 'Terms of Service',
  footerCopyright: 'Scrabble Mini Project. All Rights Reserved.',

  docsNavReadme: 'README',
  docsNavPrd: 'Product Doc (PRD)',
  docsNavStrategy: 'Strategy Guide',
  docsNavNextSteps: 'Next Steps',
  docsNavTechStack: 'Tech Stack',
  docsNavPrivacy: 'Privacy Policy',
  docsNavTerms: 'Terms of Use',
  docsLoading: 'Loading document...',
  docsErrorPrefix: 'Error:',

  aboutTitle: 'About Scrabble Mini',
  aboutSubtitle:
    'A fast, friendly practice suite for Scrabble players—built to help you validate plays, find better moves, and turn a rack of tiles into points (and bragging rights).',
  aboutCtaValidate: 'Validate a word',
  aboutCtaFind: 'Find a move',
  aboutCtaSolve: 'Solve a rack',
  aboutWhyTitle: 'Why',
  aboutWhyHeadline: 'Practice smarter (and play more confidently)',
  aboutWhyBody:
    'Scrabble is equal parts vocabulary, probability, and board awareness. This app gives you quick feedback and useful tooling so practice feels productive—not like guess-and-check.',
  aboutHowTitle: 'How',
  aboutHowHeadline: 'Tools that stay out of your way',
  aboutHowBullet1: 'Instant validation and scoring with a letter-by-letter breakdown.',
  aboutHowBullet2: 'Powerful filters to uncover high-value plays by letter, position, and length.',
  aboutHowBullet3: 'Anagram solving with wildcard support for realistic rack practice.',
  aboutBuiltTitle: 'Built',
  aboutBuiltHeadline: 'Modern, fast, and thoughtfully designed',
  aboutBuiltBody:
    'Built with React + TypeScript and a performance-first approach so the UI stays snappy—even with a large dictionary. Dark mode included, because late-night practice is real.',
  aboutToolsTitle: 'The Toolkit',
  aboutToolsSubtitle:
    'Three focused tools that cover the core practice loops: validate, search, and solve. Each one is designed to be quick to use—so you can spend time playing, not clicking.',
  aboutCtaBackHome: 'Back to Home',
  aboutToolValidatorDesc:
    'Check if a word is valid and see how the score is built—perfect for learning letter values and avoiding challenges.',
  aboutToolFinderDesc:
    'Explore top scoring words by letter and constraints—great for building intuition around hooks, prefixes, and high-value tiles.',
  aboutToolAnagramDesc:
    'Turn a rack into options. Find bingos, test wildcards, and discover words you didn’t know you knew.',
  aboutWhatYouGetTitle: 'What you get',
  aboutWhatYouGet1: 'A large dictionary dataset with fast client-side lookups.',
  aboutWhatYouGet2: 'Clear scoring breakdowns to help you learn patterns quickly.',
  aboutWhatYouGet3: 'Practical filters that match real board situations.',
  aboutWhatYouGet4: 'A clean UI with bilingual support (EN/ES) and dark mode.',
  aboutPlayfulTitle: 'One playful tip',
  aboutPlayfulBody:
    'If you ever feel stuck, try shifting your goal from “best word” to “best position.” Sometimes a small word that opens a premium square is the real power play.',
  aboutPlayfulTip:
    'Pro-tip: Practice with a timer. Speed plus accuracy is how good racks become great turns.',
} as const;

export type StringKey = keyof typeof en;

const es: Record<StringKey, string> = {
  appName: 'Scrabble Mini',
  taglineLong: 'SUPERA. PIENSA. GANA.',
  taglineShort: 'PIENSA',
  navValidator: 'Validador',
  navFinder: 'Buscador',
  navAnagram: 'Anagrama',
  navMagic: 'Magia',
  navPractice: 'Práctica',
  navDocs: 'Docs',
  languageLabel: 'Idioma',
  languageEnglish: 'English',
  languageSpanish: 'Español',

  wordValidatorTitle: 'Validador de Palabras',
  wordValidatorSubtitle:
    '¿No estás seguro si esa palabra es válida? ¡Escríbela y descúbrelo al instante! También verás exactamente cuántos puntos vale.',
  wordValidatorHowItWorksTitle: 'Tips Rápidos',
  wordValidatorHowItWorks1: 'Escribe cualquier palabra que quieras verificar',
  wordValidatorHowItWorks2: 'Usa * o ? para fichas en blanco',
  wordValidatorHowItWorks3: 'La verificamos contra 370,000+ palabras',
  wordValidatorHowItWorks4: 'Mira el puntaje al instante',
  wordValidatorHowItWorks5: 'Aprende cuánto vale cada letra',
  wordValidatorSlotTitle: 'Palabra #{slot}',
  wordValidatorCheckWord: 'Verificar palabra',
  wordValidatorInputPlaceholder: 'Ingresa una palabra (ej., SCRABBLE)',
  wordValidatorCheckButton: 'Verificar',
  wordValidatorCheckingButton: 'Verificando...',
  wordValidatorErrorEmpty: 'Ingresa letras A–Z (usa * o ? para blancos)',
  wordValidatorErrorBlanks: 'No se pueden validar palabras con blancos',
  wordValidatorErrorLookupFailed: 'Falló la búsqueda',
  wordValidatorLabelWord: 'Palabra:',
  wordValidatorLabelValidity: 'Validez:',
  wordValidatorNotChecked: 'Sin verificar',
  wordValidatorValid: 'Válida',
  wordValidatorNotInDictionary: 'No está en el diccionario',
  wordValidatorLabelBaseScore: 'Puntaje base:',
  wordValidatorLetterBreakdownTitle: 'Detalle por letra:',
  wordValidatorBlankLabel: '(blanco)',
  wordValidatorPointsSuffix: 'pts',
  wordValidatorScoringRefTitle: 'Referencia de Puntaje',
  wordValidatorPointsLabel1: '1 punto:',
  wordValidatorPointsLabel2: '2 puntos:',
  wordValidatorPointsLabel3: '3 puntos:',
  wordValidatorPointsLabel4: '4 puntos:',
  wordValidatorPointsLabel5: '5 puntos:',
  wordValidatorPointsLabel8: '8 puntos:',
  wordValidatorPointsLabel10: '10 puntos:',
  wordValidatorNoteBaseOnly:
    'Nota: Los puntajes mostrados son valores base. El puntaje real incluye multiplicadores del tablero.',

  // AI Definition Card
  definitionCardTitle: 'Definición',
  definitionCardNoWord: 'Sin palabra aún',
  definitionCardPrompt: '¡Verifica una palabra y te mostramos qué significa!',
  definitionCardInvalidWord: 'Mmm, esa no está en nuestro diccionario',
  definitionCardInvalidPrompt: 'Prueba otra palabra para ver su definición.',
  definitionCardLoading: 'Buscándola...',
  definitionCardError: '¡Ups! No pudimos obtener la definición',
  definitionCardExamples: 'Ejemplos',
  definitionCardEtymology: 'Etimología',
  definitionCardScrabbleTip: 'Tip de Scrabble',

  wordFinderTitle: 'Buscador de Palabras',
  wordFinderSubtitle:
    '¿Tienes una letra difícil como Q o Z? Te mostramos las mejores palabras para jugarla. Filtra por posición y longitud.',
  wordFinderProTipTitle: 'Tip Útil',
  wordFinderProTipText:
    '¿Buscas palabras que terminen en "S"? ¡Genial para enganchar palabras existentes! O prueba buscar palabras que empiecen con "Q" cuando tengas esa ficha difícil.',
  wordFinderFiltersTitle: 'Filtros de búsqueda',
  wordFinderQuickSelectTitle: 'Selección rápida (letras de alto valor):',
  wordFinderSelectLetterLabel: 'Selecciona letra:',
  wordFinderLetterPositionLabel: 'Posición de la letra:',
  wordFinderPositionAnywhere: 'En cualquier parte',
  wordFinderPositionStarts: 'Empieza con',
  wordFinderPositionEnds: 'Termina con',
  wordFinderWordLengthLabel: 'Longitud: {min} - {max} letras',
  wordFinderMinLabel: 'Mín: {value}',
  wordFinderMaxLabel: 'Máx: {value}',
  wordFinderQuickPresetsTitle: 'Atajos:',
  wordFinderPresetTwoLetter: 'Palabras de 2 letras',
  wordFinderPresetBingo: '7 letras (Bingo)',
  wordFinderPresetAll: 'Todas',
  wordFinderSidebarTitle: 'Letra:',
  wordFinderStatPointValue: 'Valor',
  wordFinderStatTotalWords: 'Total',
  wordFinderStatHighestScore: 'Máximo',
  wordFinderStatAverageScore: 'Promedio',
  wordFinderResultsTitle: 'Top 10 resultados',
  wordFinderLoading: 'Cargando...',
  wordFinderNoWordsTitle: 'No se encontraron palabras con esos filtros.',
  wordFinderNoWordsHint: 'Prueba ajustando los filtros.',
  wordFinderTableRank: 'Rango',
  wordFinderTableWord: 'Palabra',
  wordFinderTableLength: 'Longitud',
  wordFinderTableScore: 'Puntaje',

  anagramTitle: 'Solucionador de Anagramas',
  anagramSubtitle:
    '¿Atascado con un rack de fichas? ¡Ingrésalas aquí y encontraremos todas las palabras que puedes formar. Quizás descubras algunas nuevas!',
  anagramProTipTitle: '¿Sabías que...?',
  anagramProTipText:
    '¡Usa las 7 fichas y obtienes un bono de 50 puntos! Eso se llama BINGO. Usa ? o * para fichas en blanco—pueden ser cualquier letra.',
  anagramTilesTitle: 'Tus fichas',
  anagramTilesLabel: 'Ingresa tus fichas (A-Z, usa ? o * para blancos):',
  anagramPlaceholder: 'ej., RETAINS o RETA?NS',
  anagramTilesEntered: '{count} ficha{s} ingresada{s}',
  anagramClear: 'Limpiar',
  anagramLengthLabel: 'Longitud: {min} - {max} letras',
  anagramMinLabel: 'Mín: {value}',
  anagramMaxLabel: 'Máx: {value}',
  anagramShowBingosOnly: 'Mostrar solo bingos (7+ letras)',
  anagramFindWords: 'Buscar palabras',
  anagramSolving: 'Resolviendo...',
  anagramTryExamples: 'Prueba estos ejemplos:',
  anagramExampleWithBlank: 'RETA?NS (con blanco)',
  anagramResultsSummary: 'Resumen',
  anagramSummaryPrompt: 'Ingresa tus fichas y haz clic en "Buscar palabras".',
  anagramTotalWordsFound: 'Total encontradas',
  anagramBingoWords: 'Palabras Bingo (7+)',
  anagramBingoBonus: '+50 puntos extra cada una',
  anagramBingoBadge: 'BINGO +50',
  anagramHighestScore: 'Puntaje más alto',
  anagramAverageScore: 'Puntaje promedio',
  anagramWordsFound: '{count} palabra{s} encontradas',
  anagramNoWordsFound: 'No se encontraron palabras',
  anagramNoWordsText: 'No se encontraron palabras con esas fichas.',
  anagramNoWordsHint: 'Prueba otras letras o ajusta los filtros.',
  anagramShowingTop: 'Mostrando 50 de {count}',
  anagramTableRank: 'Rango',
  anagramTableWord: 'Palabra',
  anagramTableLength: 'Longitud',
  anagramTableScore: 'Puntaje',

  // Magic Search
  magicTitle: 'Búsqueda Mágica',
  magicSubtitle: '¡Solo dinos lo que buscas en español. Nuestra IA encuentra las palabras perfectas—sin filtros complicados!',
  magicInputPlaceholder: 'Prueba: "palabras cortas con Q pero sin U" o "palabras de 7 letras con X"',
  magicSearchButton: 'Buscar',
  magicSearching: 'Buscando palabras...',
  magicExamplesTitle: 'Prueba uno de estos:',
  magicExample1: 'Palabras cortas con Q pero sin U',
  magicExample2: 'Palabras que empiezan y terminan con la misma letra',
  magicExample3: 'Palabras de alto puntaje usando solo vocales',
  magicResultsTitle: 'Esto es lo que encontramos',
  magicNoResults: 'Mmm, ninguna palabra coincide. ¡Intenta preguntar de otra forma!',
  magicError: '¡Ups! Algo salió mal',
  magicWhyTitle: '¿Por qué se llama Mágica?',
  magicWhyText: '¡Porque puedes describir lo que quieres! En vez de usar filtros, simplemente escribe cosas como "palabras con letras dobles" o "palabras de 5 letras que terminen en -ING" y lo descubrimos.',
  magicPoweredBy: 'Impulsado por IA',

  // Practice Game
  practiceTitle: 'Práctica de Palabras',
  practiceSubtitle: 'Forma palabras, vence al reloj y acumula puntos. ¿Cuánto puedes lograr?',
  practiceHowToPlay: 'Cómo Jugar',
  practiceRule1: 'Haz clic o escribe letras para formar una palabra (mínimo 3 letras).',
  practiceRule2: 'Presiona Enter o toca Enviar para verificar y ganar puntos.',
  practiceRule3: 'Cada letra = 5 puntos. ¡Las palabras largas (5+) dan bono!',
  practiceRule4: '60 segundos por ronda, 5 minutos en total. ¡Letras nuevas cada ronda!',
  practiceStartGame: 'Iniciar Juego',
  practiceGameOver: '¡Buen Trabajo!',
  practiceFinalScore: 'Tu Puntaje',
  practiceWordsPlayed: '{count} palabras jugadas',
  practicePlayAgain: 'Jugar de Nuevo',
  practiceTotalScore: 'Puntaje',
  practiceGameTime: 'Juego',
  practiceRoundTime: 'Ronda',
  practiceSelectedWord: 'Tu Palabra',
  practiceSelectLetters: 'Toca las letras para formar una palabra...',
  practiceMinLetters: 'Necesitas al menos {count} letras',
  practicePoints: 'pts',
  practiceBonus: 'bono',
  practiceInvalidWord: 'Mmm, ¡eso no es una palabra!',
  practiceCheckFailed: '¡Ups! No pudimos verificar eso',
  practiceClear: 'Limpiar',
  practiceSubmit: 'Enviar',
  practiceChecking: 'Verificando...',
  practiceSkipRound: 'Saltar Ronda',
  practiceGetHint: 'Pedir Pista',
  practiceHintLoading: 'Pensando...',
  practiceHintTitle: 'Pista IA',
  practiceHintBestWords: 'Mejores palabras posibles con tus letras:',
  practiceHintMaxScore: 'Puntaje máximo posible',
  practiceRoundScore: 'Puntaje de ronda',
  practiceHelpTip: 'Escribe o haz clic en las letras. Enter = enviar, Backspace = borrar, Escape = limpiar.',
  practiceKeyboardTitle: 'Tips de Teclado',
  practiceKeyboardType: 'Escribe letras para elegirlas',
  practiceKeyboardSubmit: 'Enviar tu palabra',
  practiceKeyboardRemove: 'Borrar última letra',
  practiceKeyboardClear: 'Empezar de nuevo',
  practiceGotIt: '¡Entendido!',

  homeTitle: 'Tu Compañero de Práctica',
  homeSubtitle:
    '¡Verifica palabras, encuentra buenas jugadas y convierte fichas difíciles en puntos. Todo lo que necesitas para mejorar!',
  homeCtaGetStarted: '¡Vamos!',
  homeCtaLearnMore: 'Ver qué hay',
  homeSectionToolsTitle: 'Todo lo que Necesitas',
  homeToolValidatorTitle: 'Validador de Palabras',
  homeToolValidatorDesc:
    '¿No estás seguro si una palabra es válida? Escríbela y te decimos al instante—además de cuántos puntos vale.',
  homeToolValidatorBullet1: '• Validación instantánea',
  homeToolValidatorBullet2: '• Puntaje en tiempo real',
  homeToolValidatorBullet3: '• Detalle letra por letra',
  homeToolValidatorBullet4: '• Soporte de fichas en blanco',
  homeToolFinderTitle: 'Buscador de Palabras',
  homeToolFinderDesc: '¿Tienes una letra difícil como Q o Z? Te mostramos las mejores palabras para jugarla.',
  homeToolFinderBullet1: '• Búsqueda por posición',
  homeToolFinderBullet2: '• Filtro por longitud',
  homeToolFinderBullet3: '• Estadísticas',
  homeToolFinderBullet4: '• Atajos rápidos',
  homeToolAnagramTitle: 'Solucionador de Anagramas',
  homeToolAnagramDesc:
    '¡Ingresa tus fichas y mira todas las palabras que puedes formar. Quizás descubras algunas nuevas!',
  homeToolAnagramBullet1: '• Resuelve cualquier combinación',
  homeToolAnagramBullet2: '• Soporte de comodines/blancos',
  homeToolAnagramBullet3: '• Detección de bingo (7+ letras)',
  homeToolAnagramBullet4: '• Resultados instantáneos',
  homeToolCtaTryNow: 'Probar',
  homeToolCtaExplore: 'Explorar',
  homeToolCtaSolve: 'Resolver',
  homeSectionTechTitle: 'Hecho con Tecnologías Modernas',
  homeTechReactDesc: 'Arquitectura moderna de componentes',
  homeTechTypeScriptDesc: 'Código con tipado seguro',
  homeTechTailwindDesc: 'Diseño responsivo',
  homeTechViteDesc: 'Builds ultra rápidos',
  homeHighlightsTitle: 'Por qué te Encantará',
  homeHighlightDictionaryTitle: 'Diccionario Enorme',
  homeHighlightDictionaryDesc: 'Más de 370,000 palabras—si se puede jugar en Scrabble, la tenemos.',
  homeHighlightPerformanceTitle: 'Súper Rápido',
  homeHighlightPerformanceDesc: '¡Respuestas en menos de un segundo. Sin esperas!',
  homeHighlightFilteringTitle: 'Filtros Inteligentes',
  homeHighlightFilteringDesc: 'Encuentra exactamente lo que buscas por posición, longitud o puntaje.',
  homeHighlightMobileTitle: 'Funciona en Todo',
  homeHighlightMobileDesc: 'Teléfono, tablet o computadora—simplemente funciona.',
  homeStatsWords: 'Palabras',
  homeStatsTools: 'Herramientas',
  homeStatsSpeed: 'Velocidad',
  homeStatsBilingual: 'Idiomas',
  homeAIPowered: 'Con IA',
  homeGameMode: 'Modo Juego',
  homeMagicTitle: 'Búsqueda Mágica',
  homeMagicDesc: 'Solo describe lo que quieres en español. ¡Nuestra IA hace el resto!',
  homeMagicCta: 'Probar Magia',
  homePracticeTitle: 'Práctica de Palabras',
  homePracticeDesc: '¡Compite contra el reloj y forma palabras con letras aleatorias. Como un gimnasio para tu vocabulario!',
  homePracticeCta: 'Jugar Ahora',
  homeCtaTitle: '¿Listo para Mejorar?',
  homeCtaSubtitle:
    'Entra y explora. Todas nuestras herramientas son gratis y te ayudarán a ser mejor jugador.',
  homeFooterNote:
    'Hecho con cariño para los amantes de los juegos de palabras.',

  footerToolsTitle: 'Herramientas',
  footerResourcesTitle: 'Recursos',
  footerLegalTitle: 'Legal',
  footerLinkDocs: 'Docs',
  footerLinkAbout: 'Acerca de',
  footerLinkTechStack: 'Stack',
  footerLinkGitHub: 'GitHub',
  footerLinkPrivacy: 'Privacidad',
  footerLinkTerms: 'Términos',
  footerCopyright: 'Proyecto Scrabble Mini. Todos los derechos reservados.',

  docsNavReadme: 'README',
  docsNavPrd: 'Doc de Producto (PRD)',
  docsNavStrategy: 'Guía de estrategia',
  docsNavNextSteps: 'Próximos pasos',
  docsNavTechStack: 'Stack técnico',
  docsNavPrivacy: 'Privacidad',
  docsNavTerms: 'Términos',
  docsLoading: 'Cargando documento...',
  docsErrorPrefix: 'Error:',

  aboutTitle: 'Acerca de Scrabble Mini',
  aboutSubtitle:
    'Una suite rápida y amigable para practicar Scrabble—hecha para validar jugadas, encontrar mejores movimientos y convertir tus fichas en puntos (y orgullo).',
  aboutCtaValidate: 'Validar palabra',
  aboutCtaFind: 'Buscar jugada',
  aboutCtaSolve: 'Resolver fichas',
  aboutWhyTitle: 'Por qué',
  aboutWhyHeadline: 'Practica mejor (y juega con más confianza)',
  aboutWhyBody:
    'Scrabble es vocabulario, probabilidad y visión del tablero. Esta app te da feedback rápido y herramientas útiles para que practicar sea productivo—sin adivinar.',
  aboutHowTitle: 'Cómo',
  aboutHowHeadline: 'Herramientas que no estorban',
  aboutHowBullet1: 'Validación y puntaje al instante con detalle letra por letra.',
  aboutHowBullet2: 'Filtros potentes para descubrir jugadas de alto valor por letra, posición y longitud.',
  aboutHowBullet3: 'Anagramas con soporte de comodines para practicar con racks reales.',
  aboutBuiltTitle: 'Hecho con',
  aboutBuiltHeadline: 'Moderno, rápido y bien diseñado',
  aboutBuiltBody:
    'Construido con React + TypeScript y enfoque en rendimiento para que todo responda rápido, incluso con un diccionario grande. Incluye modo oscuro.',
  aboutToolsTitle: 'Las herramientas',
  aboutToolsSubtitle:
    'Tres herramientas enfocadas en el ciclo de práctica: validar, buscar y resolver. Diseñadas para usarse rápido—para jugar más y hacer clic menos.',
  aboutCtaBackHome: 'Volver al inicio',
  aboutToolValidatorDesc:
    'Comprueba si una palabra es válida y cómo se forma el puntaje—ideal para aprender valores y evitar desafíos.',
  aboutToolFinderDesc:
    'Explora palabras de alto puntaje con restricciones—perfecto para ganchos, prefijos y letras de alto valor.',
  aboutToolAnagramDesc:
    'Convierte tu rack en opciones. Encuentra bingos, prueba comodines y descubre palabras nuevas.',
  aboutWhatYouGetTitle: 'Qué incluye',
  aboutWhatYouGet1: 'Un diccionario grande con búsquedas rápidas en el cliente.',
  aboutWhatYouGet2: 'Desglose claro de puntajes para aprender patrones más rápido.',
  aboutWhatYouGet3: 'Filtros prácticos que reflejan situaciones reales del tablero.',
  aboutWhatYouGet4: 'UI limpia con soporte bilingüe (EN/ES) y modo oscuro.',
  aboutPlayfulTitle: 'Un tip divertido',
  aboutPlayfulBody:
    'Si te atoras, cambia el objetivo de “mejor palabra” a “mejor posición”. A veces una palabra corta que abre una casilla premium es la jugada ganadora.',
  aboutPlayfulTip:
    'Consejo: practica con cronómetro. Velocidad + precisión convierten buenos racks en grandes turnos.',
};

export const STRINGS = { en, es } as const;
export type Locale = keyof typeof STRINGS;
